var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-create',{attrs:{"rule":_vm.localRule,"option":_vm.options},model:{value:(_vm.fApi),callback:function ($$v) {_vm.fApi=$$v},expression:"fApi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }